import { render, staticRenderFns } from "./IsForm.vue?vue&type=template&id=242c54c8&scoped=true"
import script from "./IsForm.vue?vue&type=script&lang=ts"
export * from "./IsForm.vue?vue&type=script&lang=ts"
import style0 from "./IsForm.vue?vue&type=style&index=0&id=242c54c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242c54c8",
  null
  
)

export default component.exports